import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges
} from '@angular/core'

const VISIBLE_PAGES = 10

@Component({
    selector: 'col-pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit, OnChanges {
    @Input() current: number
    @Input() size: number
    @Input() totalCount: number

    @Output() pageChanged = new EventEmitter<number>()
    @Output() sizeChanged = new EventEmitter<number>()

    more: boolean
    pages: number[]
    totalPages: number
    selectedSizeOpt: { value: any; text: string }
    sizeOpts = [
        { value: '', text: 'Itens por página' },
        { value: 10, text: '10' },
        { value: 20, text: '20' },
        { value: 30, text: '30' },
        { value: 50, text: '50' },
        { value: 100, text: '100' }
    ]

    constructor() {
        this.current = 0
        this.size = 0
        this.totalCount = 0
        this.totalPages = 0
        this.pages = []
        this.more = false
    }

    ngOnInit() {
        this.selectedSizeOpt = this.sizeOpts[0]
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.size || changes.totalCount) {
            this.calcTotalPages()
        }

        this.calcPages()
    }

    setCurrent(index: number) {
        if (0 < index && index <= this.totalPages) {
            this.current = index
            this.pageChanged.emit(this.current)
        }
    }

    setSize(size: number) {
        this.size = size
        this.sizeChanged.emit(this.size)
    }

    sizeInputModelChanged() {
        if (this.selectedSizeOpt === this.sizeOpts[0]) {
            this.selectedSizeOpt = this.sizeOpts[1]
        }
        this.setSize(this.selectedSizeOpt.value)
    }

    isCurrent(index: number) {
        return this.current === index
    }

    hasPrev() {
        return this.current > 1
    }

    hasNext() {
        return this.current < this.totalPages
    }

    calcTotalPages() {
        if (this.totalCount !== undefined && this.size !== undefined) {
            this.totalPages = Math.ceil(this.totalCount / this.size)
        }
    }

    toggleMore() {
        this.more = !this.more
    }

    calcPages() {
        if (
            this.current === undefined ||
            this.totalCount === undefined ||
            this.size === undefined
        ) {
            return
        }
        const half = Math.floor(this.size / 2)

        let firstPageIndex = this.current <= half ? 1 : this.current - half
        let lastPageIndex =
            this.totalPages < VISIBLE_PAGES
                ? this.totalPages
                : this.current <= half
                    ? VISIBLE_PAGES
                    : this.current + half

        if (lastPageIndex > this.totalPages) {
            lastPageIndex = this.totalPages
        }

        if (lastPageIndex === this.totalPages) {
            const newFirstPageIndex = this.totalPages - VISIBLE_PAGES
            firstPageIndex = newFirstPageIndex < 1 ? 1 : newFirstPageIndex
        }

        const pages = []

        for (let i = firstPageIndex; i <= lastPageIndex; i++) {
            pages.push(i)
        }

        this.pages = pages
    }
}



// WEBPACK FOOTER //
// ./src/app/common/pagination/pagination.component.ts